import { render } from "./IconAi.vue?vue&type=template&id=016eb0d8"
import script from "./IconAi.vue?vue&type=script&lang=ts"
export * from "./IconAi.vue?vue&type=script&lang=ts"
script.render = render

export default script